<template>
  <div class="toolbar">
    <h1 class="toolbar-title">Dashboard Editor</h1>
    <div class="tabs">
      <button v-for="tab in tabs" :key="tab.name" @click="setTab(tab.name)"
        :class="{ 'active-tab': currentTab === tab.name }">
        <div class="button-content">
          <span class="material-icons">{{ tab.icon }}</span>
          {{ tab.label }}
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolbarComponent',
  data() {
    return {
      currentTab: 'tabAll',
    }
  },
  methods: {
    setTab(tab) {
      this.currentTab = tab
      this.$emit('tab-changed', tab)
    }
  },
  props: {
    tabs: {
      type: Array,
      default: () => ([
        { name: 'tabAll', label: 'All', icon: 'icon-apps' },
        { name: 'tabLayers', label: 'Layers', icon: 'icon-layers' },
        { name: 'tabBubbles', label: 'Datas', icon: 'icon-bubble_chart' },
      ]),
    },
  },
}
</script>

<style scoped>
/* Basic toolbar styling */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  width: 100%;
}

/* Title styling */
.toolbar-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* Tab button styling */
.tabs button {
  background: none;
  border: none;
  padding: 10px 15px;
  margin: 0 5px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s, color 0.3s;
}

/* Active tab styling */
.tabs .active-tab {
  color: #1976d2;
  border-bottom: 2px solid #1976d2;
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
}


/* Icon styling */
.icon-apps,
.icon-layers,
.icon-bubble_chart {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

}

/* Specific icons */
.icon-apps:before {
  content: 'apps';
}

.icon-layers:before {
  content: 'layers';
}

.icon-bubble_chart:before {
  content: 'bubble_chart';
}

/* Hover effects */
.tabs button:hover {
  color: #1976d2;
}</style>
